import React, { memo, useMemo } from 'react'
import {
  ConfirmationModal,
  IModalAction,
  IConfirmationModalProps,
} from 'transfix-ui/components/Modals'
import { makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { useUserDetails } from 'utils/hooks'

const useSignOutModalStyles = makeStyles({
  root: {
    color: brandColors.coolGray8,
  },
})

export interface ISignOutModalProps extends Omit<IConfirmationModalProps, 'actions'> {}

const SignOutModal = memo<ISignOutModalProps>(({ onClose, ...props }) => {
  const { logout } = useUserDetails()
  const classes = useSignOutModalStyles()
  const actions: IModalAction[] = useMemo(() => {
    return [
      {
        label: 'Cancel',
        type: 'dismiss',
        action: onClose,
      },
      {
        label: 'Sign out',
        type: 'confirm',
        action: () => {
          logout()
        },
      },
    ]
  }, [logout, onClose])
  return (
    <ConfirmationModal
      title='Are you sure that you want to sign out?'
      dataTest='SignOutModal'
      actions={actions}
      onClose={onClose}
      size={3}
      open
      className={classes.root}
      {...props}>
      <Typography variant='body1' component='div'>
        Signing out of Stark will prevent you from being assigned new tasks.
      </Typography>
    </ConfirmationModal>
  )
})

export default SignOutModal
